module.exports = "/_next/static/images/SDLogo-99cdec6d4e079117d57c61b2a05417e5.png";